import React from 'react';

function Header() {
	return <header className="text-center">Signature Generator</header>;
}

export default Header;
